import axios from 'axios';

class UploadFileService {
    
    upload(file, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);

        return axios.post("/api/store-registration-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    }

    uploadSpreadsheet(file, academicYearId, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);
        formData.append("academic_year_id", academicYearId);

        return axios.post("/api/store-registration-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    }
    
    uploadPicture(file, id, file_type, onUploadProgress) {
        let formData = new FormData();

        formData.append("file", file);       
        formData.append('id', id);
        formData.append('file_type', file_type);

        return axios.post("/api/student-file", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            onUploadProgress
        });
    }

    getPicture($student_id) {
        return axios.get("/api/student-picture/"+$student_id)
    }

    delete(id, file_name, file_type) {
        return axios.delete("/api/student-file", {
            params:{
                student_id: id,
                file_type: file_type,
                file_name: file_name
            }
        });
    }
}

export default new UploadFileService();